export const MINIMUM_API_VERSION = 0;
export const MAXIMUM_API_VERSION = 2;
